import React from 'react'
import { LeshenPhoneCTA } from '@leshen/gatsby-theme-leshen'
import { Header as LeshenHeader } from '@leshen/gatsby-theme-leshen'
import { StaticImage } from 'gatsby-plugin-image'
import headerData from '../data/headerData'

function Header({ statesOnly = false, logoLink = '/availability' }) { 
  const navData = statesOnly ? [headerData[0]] : headerData
  return (
    <LeshenHeader
      navData={navData}
      topBarTextColor="black"
      logoLink={logoLink}
      logo={
        <StaticImage
          width={128}
          height={50}
          src="../images/hughesnet-logo.png"
          alt="logo"
          placeholder="blurred"
        />
      }
      callToActions={
        <LeshenPhoneCTA cobra="Swap with Cobra CTA" color="tertiary" />
      }
    />
  )
}

export default Header
